<template lang="pug">
.box-course
  .box-course-home
    .box-course-top  
      span.beehive 
        img(src="../../../../assets/images/faces/ic_mark_khoahocc@2x.png")          
      .title {{$t("landing.course.title")}}
      //- router-link.view-more(:to="{ name: 'page_course'}") {{$t("home.view_more")}} >>
      a.view-more(@click="commingSoon") {{$t("home.view_more")}} >>
    .box-course-search
      .input-group
        input(:placeholder="$t('landing.course.keyword')" v-model="key_course" @keyup="onCourseChange")
        .addons-button-clear(@click="onCourseClear" v-bind:style="clear_course ? 'display:block;' : 'display:none;' ")
        .addons-button(@click="onCourseSearch")
          span.material-icons search
    .box-course-content
    .clearfix
  .clearfix
</template>
<script>
// import gql from 'graphql-tag'
// import graphql from '../../../Model/graphqlfront'
import FrontItem from '../course/Item'
import MdNotification from '@/core/components/mdNotification'
export default {
  components: {
    FrontItem,
    MdNotification
  },
  data() {
    return {
      lstCourses: [],
      key_course: '',
      clear_course: 0,
      message: this.$t('home.comming_soon'),
      no_data: this.$t('home.no_data')
    }
  },
  methods: {
    showNotification(message, color, from, align, timeout) {
      this.$notifications.notify({
        type: color,
        icon: 'notifications',
        message: message,
        placement: {
          from,
          align
        },
        timeout: timeout
      })
    },
    onCourseAll() {
      this.$router.push({name: 'page_course'})
    },
    onCourseSearch() {
      this.autoRefresh()
    },
    onCourseChange(events) {
      if (events.key === 'Enter') {
        this.onCourseSearch()
      } else {
        if (this.key_course.trim().length) this.clear_course = 1
        else this.onCourseClear()
      }
    },
    onCourseClear() {
      this.key_course = ''
      this.clear_course = 0
      this.autoRefresh()
    },
    numberWithCommas(number) {
      if (number !== undefined && number !== null) {
        return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      }
      return 0
    },
    commingSoon() {
      this.showNotification(this.message, 'warning', 'top', 'right', 7000)
    },
    async autoRefresh() {
    }
  },
  async mounted () {
    await this.autoRefresh()
  },
  apollo: {
  }
}
</script>
<style lang="scss">
.front-landing-page{
  .content.front{
    .box-course-home{margin-top:0; margin-bottom: 0px; padding-bottom:20px;
      .box-course-top{
        .title{text-align: left;font-weight: bold; font-size: 25px;letter-spacing: 0px;color: #23180A;text-transform: uppercase; display: inline-block; position: relative;}
        .view-more{cursor: pointer;  float: right;  color: #1A0DAB; font-size:15px;margin-top:5px;}
        .view-more.mobile{display: none;}
        span.beehive { width: 42px; height: 50px;transform: matrix(0, 1, -1, 0, 0, 0); position: relative;margin-right: 7px;top: -5px;
          img {max-width: 100%; width: 50px;}
        }
      }
      .box-course-search{margin: 10px 0 20px;position: relative;
        input{display:block; border: 1px solid #9F6A28; border-radius: 10px; padding: 12px 75px 12px 15px; width: 500px;background: #fff;}
        input::placeholder{color: #B4B4B4;}
        input::-moz-placeholder{color: #B4B4B4;}
        input::-webkit-input-placeholder {color: #B4B4B4;}
        input::-ms-input-placeholder {color: #B4B4B4;}
        .addons-button{cursor: pointer; background: #FFEF45; display: inline-block; position: absolute; right:1.5px; top:1.5px;width: 40px;  height: 44px;border-radius: 10px; border-top-left-radius: 0;border-bottom-left-radius: 0;
            span{transform: translate(9px, 12px); color: #9F6A28;}
        }
        .addons-button-clear{cursor: pointer;display: none; background: url("../../../../assets/images/faces/ic_clear_24px.png") no-repeat center center; position: absolute; right:40px; top:1px;width: 40px;  height: 44px;border-radius: 5px; border-top-left-radius: 0;border-bottom-left-radius: 0;}
      }
      .box-course-content{height: 474px;background: #FBF4D2 0% 0% no-repeat padding-box; border-radius: 10px;
        .view-more.mobile{display: none;color: #1A0DAB;}
        .no-data{text-align: center; margin: 15px 0;color: #9F6A28; font-size:15px;}
      }
    }
  }
}
@media (max-width: 1366px){
  .content.front{
    .box-course-home{
      .box-course-content{
        .view-more.mobile{ display: none;}
      }
    }
  }
}
@media (max-width: 1024px){
  .content.front{
    .box-course-home{
      .box-course-content{
        .view-more.mobile{ display: none;}
      }
    }
  }
}
@media (max-width: 991px){
  .content.front{
    .box-course-home{
      .box-course-content{
        .box-parent-course{width: 50%;}
      }
    }
  }
}
@media (max-width: 768px){
  .content.front{
    .box-course-home{
      .box-course-top{
        .title{font-size:20px;}
      }
      
      .box-course-search{
        .input-group{width: 100%;
          input{width: 100%;}
        }
      }
    }
  }
}
@media (max-width: 560px){
  .content.front{
    .box-course-home{
      .box-course-top{
        .title{font-size:18px;}
        .view-more{display: none;}
      }
      .box-course-content{
        .view-more.mobile{ display: block; text-align: center; margin-bottom:20px;}
        .box-parent-course{width: 100% !important;
            .box-item-course{height: 150px;}
        }
      }
      .box-course-search{
        .input-group{width: 100%;
            input{width: 100%;}
        }
      }
    }
  }
}
@media (max-width: 375px){
  .content.front{
    .box-course-home{
      .box-course-top{
        .title{font-size:18px;}
        .view-more{display: none;}
      }
      .box-course-content{
        .view-more.mobile{ display: block; text-align: center; margin-bottom:20px;}
        .box-parent-course{width: 100%;
            .box-item-course{height: 150px;}
        }
      }
      .box-course-search{
        .input-group{width: 100%;
            input{width: 100%;}
        }
      }
    }
  }
}
</style>




// WEBPACK FOOTER //
// index.vue?1e384012